import {Receipt, DashboardOutlined, ManageSearch, PersonOffOutlined, Person, LocalOfferOutlined} from '@mui/icons-material';

export const router = {
  error: '/error',
  login: '/',
  signUp: '/signup',
  verify: '/verify',
  reset: '/reset',
  main: '/main',
  payForParking: '/ParkingPayment',
  payAnInfraction: '/InfractionPayment',
  history: '/history',
  permits: '/permits',
  zone: '/zone',
  pay_ticket: '/pay_ticket',
  suite: "/suite",
  dashboard: "/suite/dashboard",
  organizations: "/suite/organizations",
  cities: "/suite/cities",
  zones: "/suite/zones",
  rates: "/suite/rates",
  users: "/suite/users",
  parkings: "/suite/parkings",
  businessPlates: "/suite/business_plates",
  tenentPlates: "/suite/tenant_plates",
  managePermits: "/suite/manage_permits",
  visitorPlates: "/suite/visitor_pass",
  public_private_note: "/suite/public_private_note",
  module: "/suite/module",
  ticket: "/suite/ticket",
  tickets_issued: "/suite/tickets_issued",
  permission: "/suite/permission",
  profile: "/profile",
  external_parking_config: "/suite/external_parking_config",
  reporting: "/suite/reporting",
  conditionOfUse: "/condition_of_use",
  privacyPolicy: "/privacy+policy",
  virtualMeterAd: "/suite/virtual_meter_ads",
  agent: '/agent',
  agentSignin: '/agent',
  agentReset: '/agent/reset',
  agentIssueTicket: '/agent/issue_ticket',
  agentHistory: '/agent/history',
};

export const adminRoutes = [
  {
    parent: {
      title: 'profile',
      path: router.profile,
      icon: <Person />
    },
    child: []
  },
  {
    parent: {
      title: 'pay_for_parking',
      path: router.main,
      icon: <Receipt />
    },
    child: []
  },
  {
    parent: {
      title: 'history',
      path: router.history,
      icon: <ManageSearch />
    },
    child: []
  },
  {
    parent: {
      title: 'permits',
      path: router.permits,
      icon: <LocalOfferOutlined />
    },
    child: []
  },
]